import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  FileProgressesWithPaginationDto,
  PaginatedListOfFileProgressesWithPaginationDto,
} from 'src/app/core/api/models';
import { PhonebookFileProgressesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { GetEnumValuesDto } from '../../../core/api/models/get-enum-values-dto';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';

@Component({
  selector: 'app-phonebook-file-progresses',
  templateUrl: './phonebook-file-progresses.component.html',
  imports: [BaseIndexModule],
})
export class PhonebookFileProgressesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.phonebookFileProgresses;
  modelWithPagination$: Observable<PaginatedListOfFileProgressesWithPaginationDto>;
  items$: Observable<Array<FileProgressesWithPaginationDto>>;

  PhonebookFileProgressStatusTypeEnumValues: GetEnumValuesDto[] = [];

  // binding component CRUD endpoints
  protected currentService = inject(PhonebookFileProgressesService);
  paginationApiMethodName: string =
    this.currentService
      .phonebookFileProgressesGetPhonebookFileProgressesWithPagination.name;
  // binding component CRUD endpoints

  //#endregion

  constructor() {
    super();
  }
  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = true;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('PhonebookFileProgressStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.PhonebookFileProgressStatusTypeEnumValues = values)
      );
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: `${this.tableVocabs}fileName`,
        name: 'fileName',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}status`,
        name: 'status',
        hasSearch: true,
        type: 'enum',
        enumName: 'PhonebookFileProgressStatus',
      },
      {
        title: `${this.tableVocabs}phonebookId`,
        name: 'phonebookId',
        type: 'number',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}phonebookName`,
        name: 'phonebookName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}progressPercent`,
        name: 'progressPercent',
        type: 'number',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}totalCount`,
        name: 'totalCount',
        type: 'number',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }
}
